import { render, staticRenderFns } from "./NewVenueInfo.vue?vue&type=template&id=5522b373&scoped=true&"
import script from "./NewVenueInfo.vue?vue&type=script&lang=js&"
export * from "./NewVenueInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueInfo.vue?vue&type=style&index=0&id=5522b373&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522b373",
  null
  
)

export default component.exports